// Photos de La Maison de la Charité (dossier public/photos) + quelques images
// libres de droits complémentaires, remplaçables à tout moment.
const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=72`;

export const IMG = {
  hero: "/photos/p1.jpg",
  louange: "/photos/p2.jpg",
  enseignement: "/photos/p6.jpg",
  priere: "/photos/p5.jpg",
  louange2: "/photos/p4.jpg",
  assemblee: "/photos/p1.jpg",
  welcome: u("1529156069898-49953e39b3ac", 1400),
  convivialite: u("1469571486292-0ba58a3f068b", 1200),
  about: "/photos/p5.jpg",
  bibleStudy: u("1529070538774-1843cb3265df", 1200),
  giving: u("1593113598332-cd288d649433", 1200),
  contact: u("1445019980597-93fa8acb246c", 1400),
  firstVisit: "/photos/p3.jpg",
  volunteers: u("1559027615-cd4628902d4a", 1200),
  hands: "/photos/p1.jpg",
  books: u("1519452575417-564c1401ecc0", 1200),
  gallery: [
    "/photos/p1.jpg",
    "/photos/p2.jpg",
    "/photos/p6.jpg",
    u("1469571486292-0ba58a3f068b", 1000),
    "/photos/p3.jpg",
    "/photos/p4.jpg",
    "/photos/p5.jpg",
  ],
};
